import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  variant: 'solid',
  fontFamily: 'roboto',
  fontWeight: 'bold',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
};
